import React, { useMemo } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useTheme } from '../../../hooks/useTheme'
import { AttackLogCard } from '../../../components/turn/AttackLogCard'
import { ContinuousAttackControl } from '../../../components/turn/ContinuousAttackControl'
import { TurnControlCard } from '../../../components/turn/TurnControlCard'
import { FreeFortifyPanel } from '../../../components/turn/FreeFortifyPanel'
import { FormattedLogText } from '../../../components/game/FormattedLogText'
import { buildActiveGameViewProps } from '../../../preview/buildActiveGameViewProps'
import { game } from '../../../preview/fixtures/cardBonusOnly'
import { TURN_PANEL_COLORS } from '../../../lib/turnPanelAppearance'

/** Stable captures of the real combat controls, including low-contrast names. */
export default function AttackReportCheckpoint() {
  const { theme } = useTheme()
  const ink = theme === 'dark' ? '#e6e1c4' : '#18170f'
  const state = useMemo(() => {
    const hydrated = buildActiveGameViewProps(game).gameState!
    const [from, to] = hydrated.map.territories
    return { ...hydrated, phase: 'attack' as const,
      lastConquest: { fromTerritoryId: from!.id, toTerritoryId: to!.id, armiesAlreadyMoved: 1 },
      map: { ...hydrated.map, territories: hydrated.map.territories.map(t => t.id === from!.id ? { ...t, armies: 2, ownerId: '1' } : t.id === to!.id ? { ...t, armies: 1, ownerId: '1' } : t) },
    }
  }, [])
  const highlights = [{ text: 'yakuza', color: '#374151' }, { text: 'Tamerlane', color: '#1D4ED8' }]
  return <ScrollView style={{ flex: 1, backgroundColor: TURN_PANEL_COLORS[theme].background }} contentContainerStyle={{ padding: 12, gap: 12, alignItems: 'center' }}>
    <View style={{ width: '100%', maxWidth: 620, gap: 12 }}>
      <Text className="font-typed" style={{ color: ink, fontSize: 14 }}>Combat report and control readability</Text>
      <TurnControlCard>
        <ContinuousAttackControl value={false} available={false} onChange={() => undefined} />
        <ContinuousAttackControl value available onChange={() => undefined} />
      </TurnControlCard>
      <AttackLogCard rollCount={1} summary="yakuza (1 lost) vs Tamerlane (1 lost)" highlights={highlights} conquered expanded={false} onToggle={() => undefined} />
      <AttackLogCard rollCount={3} summary="yakuza (2 lost) vs Tamerlane (4 lost)" highlights={highlights} conquered={false} expanded onToggle={() => undefined}>
        <FormattedLogText text="1. [6][3][1] vs [5][3] (1 lost, 1 lost)" diceSize={26} fontSize={14} color={ink} className="font-typed" style={{ color: ink, fontSize: 14 }} />
      </AttackLogCard>
      <FreeFortifyPanel gameId="visual-game" state={state} />
    </View>
  </ScrollView>
}
